var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileThemeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1215_3475)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3C9.02944 3 5 7.02944 5 12C5 16.9706 9.02944 21 14 21H16C17.4876 21 18.891 20.6391 20.1272 20H33C37.4183 20 41 16.4183 41 12C41 7.58172 37.4183 4 33 4H20.1272C18.891 3.36093 17.4876 3 16 3H14ZM15.124 5H14C10.134 5 7 8.13401 7 12C7 15.866 10.134 19 14 19H15.124C12.6646 17.6353 11 15.012 11 12C11 8.98797 12.6646 6.36473 15.124 5ZM19.6076 18H19C15.6863 18 13 15.3137 13 12C13 8.68629 15.6863 6 19 6H19.6076C21.6404 7.2249 23 9.45367 23 12C23 14.5463 21.6404 16.7751 19.6076 18ZM22.7083 18C24.1334 16.4077 25 14.3051 25 12C25 9.69494 24.1334 7.59227 22.7083 6H33C36.3137 6 39 8.68629 39 12C39 15.3137 36.3137 18 33 18H22.7083Z",
    fill: "#39A6EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1215_3475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 22,
    fill: "white",
    transform: "translate(4 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileThemeDark);
export default __webpack_public_path__ + "static/media/profile-theme-dark.57be211aa219a644fd8861e188d48dac.svg";
export { ForwardRef as ReactComponent };